import { CheckCircle, Globe } from "@phosphor-icons/react";
import { Badge } from "../ui/badge";
import { RegionCard } from "./RegionCard";
import { getTextPrimary, getBorderClass } from "../../lib/styleHelpers";

export function OpportunityAnalysis({ opportunity, isDark }) {
  return (
    <>
      {/* Detailed Analysis */}
      <div className="mb-6">
        <h3 className={`font-bold mb-3 text-lg ${getTextPrimary(isDark)}`}>Detailed Analysis</h3>
        <div className={`font-body text-sm leading-relaxed whitespace-pre-line ${isDark ? "text-gray-400" : "text-gray-600"}`}>
          {opportunity.detailed_analysis}
        </div>
      </div>

      {/* Market Fundamentals */}
      <div className="mb-6">
        <h3 className={`font-bold mb-3 text-lg ${getTextPrimary(isDark)}`}>Market Fundamentals</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {opportunity.market_fundamentals?.map((fundamental, i) => (
            <div key={i} className={`flex items-start gap-2 text-sm font-body ${isDark ? "text-gray-400" : "text-gray-600"}`}>
              <CheckCircle size={18} className="text-emerald-400 mt-0.5 flex-shrink-0" />
              <span>{fundamental}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Action Steps */}
      <div className="mb-6">
        <h3 className={`font-bold mb-3 text-lg ${getTextPrimary(isDark)}`}>Action Steps</h3>
        <ol className="space-y-2">
          {opportunity.action_steps?.map((step, i) => (
            <li key={i} className={`flex items-start gap-3 text-sm font-body ${isDark ? "text-gray-400" : "text-gray-600"}`}>
              <span className="w-6 h-6 bg-purple-600 text-white rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0">
                {i + 1}
              </span>
              <span>{step}</span>
            </li>
          ))}
        </ol>
      </div>

      {/* Regional Execution */}
      <div>
        <h3 className={`font-bold mb-3 text-lg flex items-center gap-2 ${getTextPrimary(isDark)}`}>
          <Globe size={20} className="text-purple-400" />
          Regional Execution Guides
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {opportunity.regional_execution?.map((region) => (
            <RegionCard key={region.region} region={region} />
          ))}
        </div>
      </div>

      {/* Data Sources */}
      {opportunity.data_sources?.length > 0 && (
        <div className={`mt-6 pt-6 border-t ${getBorderClass(isDark)}`}>
          <h3 className={`font-bold mb-3 text-sm ${getTextPrimary(isDark)}`}>Data Sources</h3>
          <div className="flex flex-wrap gap-2">
            {opportunity.data_sources.map((source) => (
              <Badge key={source.name} variant="outline" className={`text-xs font-body ${isDark ? "border-white/20 text-gray-400" : ""}`}>
                {source.name} ({source.reliability})
              </Badge>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
